import DashboardLayout from '@/views/Layout/DashboardLayout.vue';
import AuthLayout from '@/views/Pages/AuthLayout.vue';

import NotFound from '@/views/NotFoundPage.vue';

const routes = [
  {
    path: '/',
    redirect: 'login',
    component: DashboardLayout,
    children: [
      {
        path: '/dashboard/:ID_NAVE/:ID_CONSIGNATARIO',
        name: 'dashboard',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue'),
        // meta: { requiresAuth: true }

      },

      {
        path: '/detalle/:ID_NAVE/:ID_CONSIGNATARIO',
        name: 'detalle',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Detalle.vue'),
        // meta: { requiresAuth: true }

      },

      {
        path: '/reporte/:ID_NAVE/:ID_CONSIGNATARIO',
        name: 'reporte',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () => import(/* webpackChunkName: "demo" */ '../views/Reporte.vue'),
        // meta: { requiresAuth: true }

      },
      // {
      //   path: '/dashboard/:id/:id_consignatario',
      //   name: 'dashboard',
      //   component: () => import(/* webpackChunkName: "demo" */ '../views/Dashboard.vue'),
      //   props: true, // Permite pasar los parámetros como props al componente
      // },
      {
        path: '/icons',
        name: 'icons',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Icons.vue'),
        meta: { requiresAuth: true } // Añadir meta tag para requerir autenticación

      },
      {
        path: '/profile',
        name: 'profile',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/UserProfile.vue'),
        meta: { requiresAuth: true } // Añadir meta tag para requerir autenticación

      },
      {
        path: '/maps',
        name: 'maps',
        component: () => import(/* webpackChunkName: "demo" */ '../views/GoogleMaps.vue'),
        meta: { requiresAuth: true } // Añadir meta tag para requerir autenticación

      },
      {
        path: '/tables',
        name: 'tables',
        component: () => import(/* webpackChunkName: "demo" */ '../views/RegularTables.vue'),
        meta: { requiresAuth: true } // Añadir meta tag para requerir autenticación

      }
    ]
  },
  {
    path: '/',
    redirect: 'login',
    component: AuthLayout,
    children: [
      {
        path: '/login',
        name: 'login',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Login.vue')
      },
      {
        path: '/register',
        name: 'register',
        component: () => import(/* webpackChunkName: "demo" */ '../views/Pages/Register.vue')
      },
      { path: '*', component: NotFound },
    ]
  }
];

export default routes;
